import { createPinia } from 'pinia';
import { createApp } from 'vue';
import '@/setup/_scss.scss';
import options from '@/setup/options.js';
import plugins from '@/setup/plugins.js';

const vuePlugins = plugins;
const pinia = createPinia();
let vueOptions = options;

if (import.meta.env.DEV) {
  const styleguideOptions = await import('@!production/styleguide/setup');

  vueOptions = {
    ...vueOptions,
    ...styleguideOptions.options,
  };

  vuePlugins.push(...styleguideOptions.plugins);
}

const app = createApp(vueOptions);

// We need to store to global properties on the store object in order to have access to it.
pinia.use(() => ({
  _vm: {
    $cdc: app.config.globalProperties.$cdc,
    $gtm: app.config.globalProperties.$gtm,
  },
}));

app.use(pinia);

vuePlugins.forEach(({ plugin, options: pluginOptions }) => app.use(plugin, pluginOptions));

app.mount('#app');

// Anchor link scrolling fix for Vue apps
// https://tracker.ivoclarvivadent.com/browse/CA-6545
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.hash) {
    const LOADING_DELAY = 150;

    setTimeout(() => {
      const element = document.getElementById(window.location.hash.replace('#', ''));

      if (element) {
        element.scrollIntoView();
      }
    }, LOADING_DELAY);
  }
});
